module.exports = __webpack_public_path__ + "media/1_3-2.be7df4ab.mp3";